import axios from 'axios'
import { AssayModalAssayWithValuableConceptResponse } from '@/components/assays-view/services/assays-view-assay/assays-view-assay.dto'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class AssaysViewAssayService {
    async getAssays(laboratoryId: number): Promise<AssayModalAssayWithValuableConceptResponse[]> {
        const response = await axios.get<AssayModalAssayWithValuableConceptResponse[]>(`/assaysView/laboratories/${laboratoryId}/assays`)
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
    }

    async getCompletedAssays(laboratoryId: number): Promise<AssayModalAssayWithValuableConceptResponse[]> {
        const response = await axios.get<AssayModalAssayWithValuableConceptResponse[]>(`/assaysView/laboratories/${laboratoryId}/assaysThatHadBeenCompleted`)
        return response.data
    }

    async searchAssays(currentLaboratoryId: number, laboratoryIds: number[], searchText: string): Promise<AssayModalAssayWithValuableConceptResponse[]> {
        const params = { searchText: searchText ?? '', laboratoryIds }
        const response = await axios.get<AssayModalAssayWithValuableConceptResponse[]>(
            `/assaysView/laboratories/${currentLaboratoryId}/assays/search`, { params })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
    }
}

export const assaysViewAssayService = new AssaysViewAssayService()
